import type { IAppPricingPlan } from './types';
import type {
  MeterdBilling,
  PlanDescription,
} from '@wix/app-market-components';
import type { IAppPlan } from '../apps-plans';
import type { IPricingModelPlan } from '../pricing-model';

/**
 * Represents a unified class for managing app pricing plan .
 * Retrieves app plans from the app-plans service and pricing models from the pricing-proxy service.
 * @class
 */
export class AppPricingPlan {
  constructor(
    private readonly appPlan: IAppPlan,
    private readonly pricingModelPlan: IPricingModelPlan,
  ) {}

  get vendorId(): string {
    return this.pricingModelPlan.vendorId;
  }
  get name(): string {
    return this.pricingModelPlan.name;
  }

  get title(): string | undefined {
    return this.pricingModelPlan.title;
  }

  get isVisible(): boolean {
    return this.pricingModelPlan.isVisible;
  }

  get isFree(): boolean {
    return this.pricingModelPlan.isFree;
  }

  get description(): PlanDescription {
    return this.pricingModelPlan.description;
  }
  get meterdBilling(): MeterdBilling | undefined {
    return this.appPlan.meterdBilling;
  }
  get yearlyPrice(): string | undefined {
    return this.appPlan.yearlyPrice;
  }
  get monthlyPrice(): string | undefined {
    return this.appPlan.monthlyPrice;
  }

  toJSON(): IAppPricingPlan {
    return {
      vendorId: this.vendorId,
      name: this.name,
      title: this.title,
      isVisible: this.isVisible,
      isFree: this.isFree,
      description: this.description,
      meterdBilling: this.meterdBilling,
      yearlyPrice: this.yearlyPrice,
      monthlyPrice: this.monthlyPrice,
    };
  }
}
